module.exports = __webpack_public_path__ + "img/my_gift_icon_active.78bfe585.svg";